export const alertDetailsPageTestIDs = {
  alertDetailsPage: 'alert_details_modal',
  eventDescription: 'alert_details_modal_event_description',
  expireTimeText: 'alert_details_modal_expire_time',
  detailText: 'alert_details_modal_detail_text',
  alertDetailsFocus: 'alert_details_modal_focus',
};
